import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetOrderAddressesInput } from './GetOrderAddressesInput';
import { GetOrderAddressesOutput } from './GetOrderAddressesOutput';

export class GetOrderAddressesService extends HttpServiceBase {

  handle = (input: GetOrderAddressesInput): Promise<Result<GetOrderAddressesOutput> | null> => {
    const promise = this.http.get<Result<GetOrderAddressesOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/addresses`);
    return promise;
  }
}